export const companyData = {
    companyName: "ABC Corporation",
    // incorporationDate: "01 Oct, 2022",
    corporationNumber: "123456789",
    registeredAddress: "1234 Innovation Street, Suite 200, Tech City, CA",
    recordAddress: "1234 Innovation Street, Suite 200, Tech City, CA",
    businessAddress: "1234 Innovation Street, Suite 200, Tech City, CA"
};

export const directors = [
    {
        name: "John Smith",
        address: "4321 Enterprise Blvd, Floor 10, Innovation City, NY",
        title: "CEO",
        dob: "12 Feb, 1985",
        contact: "555-123-4567",
        fax: "555-987-6543",
        email: "john.smith@example.com",
        website: "www.johnsmithconsulting.com",
        calendarLink: "www.calendarlink.com/johnsmith",
        signature: "path/to/signature1.jpg"
    },
    {
        name: "Sara Lee",
        address: "5678 Market Street, Suite 500, Business Town, TX",
        title: "Chief Financial Officer",
        dob: "25 May, 1978",
        contact: "555-234-5678",
        fax: "555-876-5432",
        email: "sara.lee@example.com",
        website: "www.leefinance.com",
        calendarLink: "www.calendarlink.com/saralee",
        signature: "path/to/signature2.jpg"
    },
    {
        name: "Michael Chen",
        address: "7890 Tech Avenue, Suite 300, Silicon Valley, CA",
        title: "Chief Technology Officer",
        dob: "17 Aug, 1990",
        contact: "555-345-6789",
        fax: "555-765-4321",
        email: "michael.chen@example.com",
        website: "www.cheninnovation.com",
        calendarLink: "www.calendarlink.com/michaelchen",
        signature: "path/to/signature3.jpg"
    }
];

export const incorporatorData = {
    incorporatorName: "ABC Corporation",
    firmName: "Firm Name",
    address: "1234 Innovation Street, Suite 200, Tech City, CA",
    zipCode: "90210",
    dob: "01 Oct, 2022",
    contactNumber: "123-456-7890",
    email: "abc@example.com",
    website: "www.accounting.com",
    calendarLink: "www.calendarlink.com",
    signature: "path/to/incorporator-signature.jpg",
    fax: "098-765-4321"
};
